import './summary-meta.scss'
import {
  useTranslation,
} from 'react-i18next'
import {
  Link as MuiLink,
  Typography,
} from '@mui/material'
import moment from 'moment'
import { Completed, Work } from '@vedmarket/ui-kit'
import ApplicationSectionAccordion from './application-section-accordion'
import {
  Link,
} from 'react-router-dom'

import {
  COLORS,
} from 'config/constants'
import {
  calculationPath,
} from 'utils/applicationRoutes'

const ApplicationSummaryMeta = ({ app, managerView }: ApplicationSummaryMetaProps) => {
  const { t } = useTranslation()

  const rows: ApplicationSummaryMetaRow[] = []

  if (app.cargo_description) {
    rows.push({
      label: t('applications__text__cargo'),
      value: app.cargo_description,
    })
  }
  if (app.route_summary) {
    rows.push({
      label: t('applications__text__route'),
      value: app.route_summary.replace(/\s+[-–]\s+/g, ' — '),
    })
  }

  rows.push({
    label: t('applications__text__calculation'),
    value: (
      <MuiLink
        component={Link}
        to={calculationPath(app.calculation_number)}
        target='_blank'
        rel='noopener noreferrer'
        underline='hover'
        sx={{ color: COLORS.BLUE, cursor: 'pointer', textAlign: 'left' }}
      >
        <Typography component='span' variant='inherit'>№{app.calculation_number}</Typography>
      </MuiLink>
    ),
  })

  rows.push({
    label: t('applications__text__columnDate'),
    value: moment(app.created_at).format('DD.MM.YYYY HH:mm'),
  })

  if (app.status_updated_at) {
    rows.push({
      label: t('applications__text__statusUpdated'),
      value: moment(app.status_updated_at).format('DD.MM.YYYY HH:mm'),
    })
  }

  if (managerView && app.user_email) {
    rows.push({
      label: t('applications__text__columnClient'),
      value: app.user_email,
    })
  }

  if (app.executor_company?.name) {
    rows.push({
      label: t('applications__text__executor'),
      value: app.executor_company.name,
    })
  }

  return (
    <section className='application-summary-meta'>
      <ApplicationSectionAccordion
        title={t('applications__text__generalInformation')}
        icon={<Work width={32} height={32} />}
      >
        <Completed info={rows} isFullRow />
      </ApplicationSectionAccordion>
    </section>
  )
}

export default ApplicationSummaryMeta
